import { useEffect, useRef } from 'react';

import { useRouter } from 'react-resource-router';

import traceUFOTransition from '@atlaskit/react-ufo/trace-transition';

/**
 * Subscribes to react-resource-router and fires a UFO transition whenever
 * the route name changes after the initial render. The first render is
 * intentionally a no-op — the initial page load is already traced by
 * `initUFO()`.
 */
export const useReactUFORouteWatcher = (): void => {
	const [{ route }] = useRouter();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		if (route?.name) {
			traceUFOTransition(route.name, route.name);
		}
	}, [route?.name]);
};
